var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCredito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.536,
    height: 23.75,
    viewBox: "0 0 30.536 23.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-credit-card",
    "data-name": "Icon awesome-credit-card",
    d: "M0,23.455A2.545,2.545,0,0,0,2.545,26H27.991a2.545,2.545,0,0,0,2.545-2.545v-9.33H0Zm10.179-3.6a.638.638,0,0,1,.636-.636h7.21a.638.638,0,0,1,.636.636v2.121a.638.638,0,0,1-.636.636h-7.21a.638.638,0,0,1-.636-.636Zm-6.786,0a.638.638,0,0,1,.636-.636H7.846a.638.638,0,0,1,.636.636v2.121a.638.638,0,0,1-.636.636H4.029a.638.638,0,0,1-.636-.636ZM30.536,4.795V7.339H0V4.795A2.545,2.545,0,0,1,2.545,2.25H27.991A2.545,2.545,0,0,1,30.536,4.795Z",
    transform: "translate(0 -2.25)",
    fill: "#9373b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredito);
export default __webpack_public_path__ + "static/media/credito.c08ed454c8fad968fb5c90e1f91462ed.svg";
export { ForwardRef as ReactComponent };